import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
let AboutComponent = class AboutComponent {
    constructor(httpClient, webSettingsService, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.about = [];
        this.details = {};
        this.secondColor = '';
        this.backColor = '';
        this.linkColor = '';
        this.mainColor = '';
        this.borderRadiusSmaller = '';
        this.httpClient.get('about_us').subscribe((data) => {
            this.about = data;
        });
        this.httpClient.get('aboutus/details').subscribe((data) => {
            this.details = data['data'];
        });
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
    }
};
AboutComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
AboutComponent = __decorate([
    Component({
        selector: 'ecd-about',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./about.component.html")).default
    })
], AboutComponent);
export { AboutComponent };
